import Link from "next/link";
import { FC } from "react";

import { RouteName } from "@/consts";
import { CommentIcon } from "@/features/common/components/icons/CommentIcon";
import { Text } from "@/features/common/components/tailwind/Text";
import { formatThousandsCountToNDecimal } from "@/features/common/helper/formatCount";
import { PostPagePostFragment } from "@/generated/generated-hooks";

import { ImageCardLikeButton } from "./ImageCardLikeButton";
import { ImageCardRemoveLikeButton } from "./ImageCardRemoveLikeButton";

type ImageCardActionBarProps = {
  post: PostPagePostFragment;
  hasCurrentUserLike: boolean;
};

export const ImageCardActionBar: FC<ImageCardActionBarProps> = (props) => {
  const { post, hasCurrentUserLike } = props;
  const { likes, commentCount, _id: postId, title, slug } = post;
  return (
    <div className="flex items-center">
      <div className="flex items-center space-x-2">
        <div className="flex items-center space-x-1">
          {hasCurrentUserLike ? (
            <ImageCardRemoveLikeButton postId={postId} />
          ) : (
            <ImageCardLikeButton postId={postId} />
          )}
          {likes > 0 && (
            <Text size="small" className="gray-500">
              {formatThousandsCountToNDecimal(likes, 1)}
            </Text>
          )}
        </div>
        <div className="flex items-center space-x-1">
          <Link href={`${RouteName.Post}/${slug}?reply`}>
            <a style={{ display: "inline-flex" }}>
              <CommentIcon
                alt="comment icon"
                className="text-gray-500 w-4 h-4"
              />
            </a>
          </Link>
          {commentCount > 0 && (
            <Text size="small" className="gray-500">
              {formatThousandsCountToNDecimal(commentCount, 1)}
            </Text>
          )}
        </div>
      </div>
    </div>
  );
};
